import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import Amplitude from "@Shared/utils/amplitude";
const allOccurrences = (source, search) => {
  const result = [];
  for (let i = 0; i < source.length; ++i) {
    if (source.substring(i, i + search.length) == search) {
      result.push(i);
    }
  }
  return result;
};
export default async file => {
  return new _Promise(resolve => {
    const reader = new FileReader();
    reader.onload = result => {
      try {
        const fileAsString = result.target.result;
        let isEncrypted = false;
        let PDFUPW = []; //PDF encryption dictionary /U password hash
        const allTrailers = allOccurrences(fileAsString, "trailer");
        const refIdsArr = [];
        allTrailers.forEach(trailer => {
          const encryptKey = _indexOfInstanceProperty(fileAsString).call(fileAsString, "Encrypt", trailer);
          if (encryptKey > 0) {
            const ref = _indexOfInstanceProperty(fileAsString).call(fileAsString, "R", encryptKey);
            const refVal = fileAsString.substring(encryptKey, ref + 1);
            const refIds = refVal.match(/Encrypt (\d+) (\d+) R/);
            refIdsArr.push(`${refIds[1]} ${refIds[2]}`);
            const encryptionObjectRef = _indexOfInstanceProperty(fileAsString).call(fileAsString, `${refIds[1]} ${refIds[2]} obj`);
            const encryptionObject = fileAsString.substring(encryptionObjectRef, encryptionObjectRef + 1000); //1000 seems like a good value to capture the encryption dictionary
            const userPassword = encryptionObject.match(/\/U(.+?)[/|\n]/);
            PDFUPW.push(userPassword == null ? void 0 : userPassword[1]);
            isEncrypted = true;
          }
        });
        resolve(isEncrypted && PDFUPW.some(p => (p == null ? void 0 : p.length) > 0));
        Amplitude.logEvent("Upload PDF - " + (isEncrypted ? "Document IS encrypted and a warning was issued" : "Document IS NOT encrypted and was allowed"), {
          file: {
            name: file.name
          },
          allTrailers,
          PDFUPW,
          refIdsArr
        });
      } catch (e) {
        resolve(false);
        Amplitude.logEvent("Upload PDF - " + "Unknown error reading file", {
          file
        });
      }
    };
    reader.readAsText(file);
  });
};